import type { ReactNode } from "react";

import styled from "styled-components";

import { colorsPalettes, rgba } from "@similarweb/styles";

const Wrapper = styled.div`
    position: relative;
`;

const Overlay = styled.div`
    position: absolute;
    inset: 0;
    z-index: 10;
    border-radius: 3px;
    background: ${rgba(colorsPalettes.carbon[0], 0.4)};
    backdrop-filter: blur(8px);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

interface IContentBlurProps {
    enabled: boolean;
    content: ReactNode;
    children: ReactNode;
}

export const ContentBlur = ({ enabled, content, children }: IContentBlurProps) => {
    return (
        <Wrapper>
            {children}
            {enabled ? <Overlay>{content}</Overlay> : null}
        </Wrapper>
    );
};
